import { UpdateDocumentFreeInputCard } from "@/features/renew-visa/components/applicationStep/formApplication/companyApplication/updateDocumentFreeInputStep/UpdateDocumentFreeInputCard";
import { FC } from "react";

export type TCompanyUpdateDocumentFreeInputProps = {
  readonly?: boolean;
};

export const CompanyUpdateDocumentFreeInput: FC<TCompanyUpdateDocumentFreeInputProps> = ({ readonly }) => {
  return <UpdateDocumentFreeInputCard readonly={readonly} />;
};
